var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        { staticClass: "py-2" },
        [
          _c("v-icon", { staticClass: "mr-2" }, [_vm._v("merge_type")]),
          _vm._v(" "),
          _c("div", { staticClass: "title info--text" }, [_vm._v("Aliases")]),
          _vm._v(" "),
          _c("div", { staticClass: "title pl-1" }, [_vm._v(" ⋅ ")]),
          _vm._v(" "),
          _c("div", { staticClass: "caption pl-1" }, [
            _vm._v(
              " " +
                _vm._s(_vm.aliases.length) +
                " " +
                _vm._s(_vm.pluralize("alias", _vm.aliases.length, "es"))
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _vm.editForm
        ? [
            _c(
              "v-card-actions",
              [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "success", small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.editName()
                      },
                    },
                  },
                  [
                    _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                    _vm._v("\n        Add..\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "warning", small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.addAlias()
                      },
                    },
                  },
                  [
                    _c("v-icon", { staticClass: "mr-1" }, [
                      _vm._v("merge_type"),
                    ]),
                    _vm._v("\n        Merge existing..\n      "),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("v-divider"),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("v-card-text", [
        _c("p", [
          _c("strong", [_vm._v("Aliases")]),
          _vm._v(
            " for this data source store a subset of data. To preserve that\n      data, these aliases cannot be removed but can be separated from the current data source.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _c("strong", [_vm._v("Name aliases")]),
          _vm._v(" are alternative names for this data source.\n    "),
        ]),
      ]),
      _vm._v(" "),
      _c("v-data-table", {
        attrs: {
          "hide-actions": "",
          items: _vm.nameAliases,
          "no-data-text": "No name aliases",
          "hide-headers": "",
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function ({ item }) {
              return [
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c("v-chip", { attrs: { label: "", small: "" } }, [
                      _vm._v("\n          " + _vm._s(item.Name) + "\n        "),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-right" }, [
                  item.IsPrimary
                    ? _c(
                        "span",
                        {
                          staticClass: "caption",
                          class: [
                            _vm.matchesLocationName(item)
                              ? "info--text"
                              : "warning--text",
                          ],
                        },
                        [
                          _vm._v("\n          Primary\n          "),
                          _c("Tooltip", {
                            attrs: {
                              text: _vm.makeTooltipText(item),
                              small: "",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editForm && !item.IsPrimary,
                          expression: "editForm && !item.IsPrimary",
                        },
                      ],
                    },
                    [
                      _vm.isSystemAdmin
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                loading: item.makePrimaryLoading,
                                color: "info",
                                small: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.makePrimary(item)
                                },
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-2" }, [
                                _vm._v("admin_panel_settings"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text--capitalize" }, [
                                _vm._v(
                                  "\n              Make primary\n            "
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { "open-delay": 500, left: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.editForm && !item.IsPrimary,
                                              expression:
                                                "editForm && !item.IsPrimary",
                                            },
                                          ],
                                          attrs: { icon: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeAlias(item)
                                            },
                                          },
                                        },
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "warning" } },
                                          [_vm._v("call_split")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c("span", [
                            _vm._v("Separate alias from current data source"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c("v-card-text", [
        _c("strong", [_vm._v("QA/QC alias")]),
        _vm._v(" data are\n    classified as QA/QC Replicate Samples.\n  "),
      ]),
      _vm._v(" "),
      _c("v-data-table", {
        attrs: {
          "hide-actions": "",
          items: _vm.qaqcAliases,
          "no-data-text": "No QA/QC aliases",
          "hide-headers": "",
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function ({ item }) {
              return [
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c("v-chip", { attrs: { label: "", small: "" } }, [
                      _vm._v("\n          " + _vm._s(item.Name) + "\n        "),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-right" }, [
                  item.IsPrimary
                    ? _c(
                        "span",
                        {
                          staticClass: "caption",
                          class: [
                            _vm.matchesLocationName(item)
                              ? "info--text"
                              : "warning--text",
                          ],
                        },
                        [
                          _vm._v("\n          Primary\n          "),
                          _c("Tooltip", {
                            attrs: {
                              text: _vm.makeTooltipText(item),
                              small: "",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editForm && !item.IsPrimary,
                          expression: "editForm && !item.IsPrimary",
                        },
                      ],
                    },
                    [
                      _vm.isSystemAdmin
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                loading: item.makePrimaryLoading,
                                color: "info",
                                small: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.makePrimary(item)
                                },
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-2" }, [
                                _vm._v("admin_panel_settings"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text--capitalize" }, [
                                _vm._v(
                                  "\n              Make primary\n            "
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { "open-delay": 500, left: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.editForm && !item.IsPrimary,
                                              expression:
                                                "editForm && !item.IsPrimary",
                                            },
                                          ],
                                          attrs: { icon: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeAlias(item)
                                            },
                                          },
                                        },
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "warning" } },
                                          [_vm._v("call_split")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c("span", [
                            _vm._v("Separate alias from current data source"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c("v-card-text", [
        _c("strong", [_vm._v("Depth/Height alias")]),
        _vm._v(" data are assigned the specified depth/height values.\n  "),
      ]),
      _vm._v(" "),
      _c("v-data-table", {
        attrs: {
          "hide-actions": "",
          items: _vm.depthHeightAliases,
          "no-data-text": "No Depth/Height aliases",
          "hide-headers": "",
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function ({ item }) {
              return [
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c("v-chip", { attrs: { label: "", small: "" } }, [
                      _vm._v("\n          " + _vm._s(item.Name) + "\n        "),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.formatDepthHeightValues(
                          item.DepthHeightStartValue,
                          item.DepthHeightEndValue
                        )
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "caption" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(item.Datum && item.Datum.DatumName) +
                        "\n          (" +
                        _vm._s(item.Datum && item.Datum.DatumType.Name) +
                        ")\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-right" }, [
                  item.IsPrimary
                    ? _c(
                        "span",
                        {
                          staticClass: "caption",
                          class: [
                            _vm.matchesLocationName(item)
                              ? "info--text"
                              : "warning--text",
                          ],
                        },
                        [
                          _vm._v("\n          Primary\n          "),
                          _c("Tooltip", {
                            attrs: {
                              text: _vm.makeTooltipText(item),
                              small: "",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editForm && !item.IsPrimary,
                          expression: "editForm && !item.IsPrimary",
                        },
                      ],
                    },
                    [
                      _vm.isSystemAdmin
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                loading: item.makePrimaryLoading,
                                color: "info",
                                small: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.makePrimary(item)
                                },
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-2" }, [
                                _vm._v("admin_panel_settings"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text--capitalize" }, [
                                _vm._v(
                                  "\n              Make primary\n            "
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { "open-delay": 500, left: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.editForm && !item.IsPrimary,
                                              expression:
                                                "editForm && !item.IsPrimary",
                                            },
                                          ],
                                          attrs: { icon: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeAlias(item)
                                            },
                                          },
                                        },
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "warning" } },
                                          [_vm._v("call_split")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c("span", [
                            _vm._v("Separate alias from current data source"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("AddAliasDialog", { ref: "addAliasDialog" }),
      _vm._v(" "),
      _c("UnmergeDialog", { ref: "unmergeDialog" }),
      _vm._v(" "),
      _c("MergeDialog", {
        ref: "mergeDialog",
        attrs: { monitoringFeature: _vm.currentMonitoringFeature },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }